import * as h from 'history';

export const history = h.createHashHistory();
